import { render, staticRenderFns } from "./projectDashboard.vue?vue&type=template&id=0d5b3912&scoped=true"
import script from "./projectDashboard.vue?vue&type=script&lang=js"
export * from "./projectDashboard.vue?vue&type=script&lang=js"
import style0 from "./projectDashboard.vue?vue&type=style&index=0&id=0d5b3912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b3912",
  null
  
)

export default component.exports